<template>
  <div>

<el-row>
  <el-col :span="12"><div class="grid-content bg-purple">
    <el-button :loading="loading" type="primary" slot="append" icon="el-icon-circle-plus" @click="onAdd">添加</el-button>
    </div></el-col>
  <el-col :span="12"><div class="grid-content bg-purple-light">
    <el-input placeholder="请输入内容" v-model="page.key" clearable @clear="onSearch" class="input-with-select">
      <el-button :loading="loading" type="primary" slot="append" icon="el-icon-search" @click="onSearch">查询</el-button>
    </el-input>
    </div></el-col>
</el-row>


  <el-table :data="list" v-loading="loading" style="width: 100%">
    <el-table-column fixed prop="id" label="ID" width="50"></el-table-column>
    <el-table-column fixed prop="media_id" label="配图" width="50">
      <template slot-scope="scope">
        <i v-if="scope.row.media_id" class="el-icon-success"></i>
      </template>
    </el-table-column>
    <el-table-column prop="articleType_id" label="分类" width="150">
      <template slot-scope="scope">
        {{scope.row.articleType_id|articleType}}
      </template>
    </el-table-column>
    <el-table-column prop="title" label="标题">
      <template slot-scope="scope">
        <a :href="ArticleBaseUrl+scope.row.id" target="_blank">{{scope.row.title}}</a>
      </template>
    </el-table-column>
    <el-table-column v-if="isadmin==1" label="发表用户" width="200">
      <template slot-scope="scope">
        {{scope.row.user?scope.row.user.name:''}}
      </template>
    </el-table-column>
    <el-table-column prop="click" label="浏览量" width="120"></el-table-column>
    <el-table-column label="状态" width="120">
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.state==-2" class="item" effect="dark" :content="scope.row.stateInfo" placement="left">
          <i class="el-icon-warning"></i>
        </el-tooltip>
        {{scope.row.state|state}}
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" width="100">
      <template slot-scope="scope">
        <!-- <el-button v-if="isadmin==1 || scope.row.state<-1" @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
        <router-link class="el-button el-button--text el-button--small" :to="{name: 'article_edit',params: {id:scope.row.id}}">编辑</router-link>
      </template>
    </el-table-column>
  </el-table>


<MyPagination :loading="loading" :page="page" @current-change="currentChange"></MyPagination>


<!-- <ArticleManager :visible.sync="dialogVisible" :item="item" @updateList="currentChange(1)"></ArticleManager> -->



  </div>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import {MyStorage } from '@/common.js';
export default {
  components: {
    MyPagination
  },
    data() {
        return {
          isadmin:MyStorage.getItem('isadmin'),
          ArticleBaseUrl:process.env.VUE_APP_ArticleBaseUrl,
          loading:false,
          page:{
            key:'',
            page:1,
            total:0,
            last_page:1,
            per_page:10
          },
          list:null,
          // item:null,
        }
    },
    mounted(){
        console.log('文章');
        this.loadData();
    },
    methods : {
      loadData(){
        this.loading=true;
        this.api.article_list(this.page,res=>{
          console.log(res.data);
          this.list=res.data.data;
          this.page.total=res.data.total;
          this.loading=false;
        });
      },
      currentChange(currentPage) {
        this.page.page=currentPage
        this.loadData();
        console.log(currentPage);
      },
      onSearch() {
        this.currentChange(1);
      },
      onAdd(){
        this.$router.push("/article/edit/0");
      }
    }
}
</script>
